import { render } from "./CardContact.vue?vue&type=template&id=30878593&scoped=true"
import script from "./CardContact.vue?vue&type=script&lang=js"
export * from "./CardContact.vue?vue&type=script&lang=js"

import "./CardContact.vue?vue&type=style&index=0&id=30878593&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30878593"]])

export default __exports__